document.addEventListener('DOMContentLoaded', function () {
	const tabs = document.querySelectorAll('.js-tab-menu-item a');
	const panels = document.querySelectorAll('.js-tab-panel');

	tabs.forEach((tab) => {
		tab.addEventListener('click', function (e) {
			e.preventDefault();

			// タブの切り替え
			tabs.forEach((t) => t.classList.remove('--is-current'));
			this.classList.add('--is-current');

			// パネルの切り替え
			const tabName = this.getAttribute('data-tab');
			panels.forEach((panel) => {
				if (panel.getAttribute('data-tab-panel') === tabName) {
					panel.classList.add('--is-active');
				} else {
					panel.classList.remove('--is-active');
				}
			});
		});
	});
});
